<template>
  <section class="fill-height">
    <v-toolbar color="#9190b5" dark prominent>
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top, rgba(25,32,72,.5), rgba(145,144,181,.5)"></v-img>
      </template>

      <v-toolbar-title class="d-flex justify-center align-center" style="width: 100%">
        <v-img :src="require(`@/assets/sqe_smart.png`)" max-width="320px"/>
      </v-toolbar-title>

      <template v-slot:extension>
<!--        <v-tabs centered v-if="profile_type && profile_type === 'aspiringSolicitor'" hide-slider>-->
<!--          <v-tab :to="{name: 'Profile'}">Profile</v-tab>-->
<!--          <v-tab :to="{name: 'Booking'}">Booking</v-tab>-->
<!--&lt;!&ndash;          <v-tab :to="{name: 'Search study group'}">Join study group</v-tab>&ndash;&gt;-->
<!--          <v-tab @click="buy_sessions_dialog = true">Buy sessions</v-tab>-->
<!--        </v-tabs>-->
      </template>
    </v-toolbar>

    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <v-toolbar dark flat color="primary" dense>
              Coming up soon
            </v-toolbar>
            <v-sheet class="overflow-y-auto" max-height="500px" color="transparent">
              <v-timeline dense>
                <v-timeline-item class="pr-3" v-for="(item, idx) in sessions" :key="idx" small>
                  <v-card>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name"/>
                        <v-list-item-subtitle>
                          {{ $moment(item.start).format('DD MMMM YYYY hh:mm A') }}
                        </v-list-item-subtitle>
                        <!--                      <v-list-item-subtitle>Attendance note: {{ session.include_an ? 'Yes' : 'No' }}</v-list-item-subtitle>-->
                      </v-list-item-content>

                      <v-list-item-action>
<!--                        <v-btn small class="box-shadow mt-3" color="success" :to="{name: 'Classroom session', params: {session_id: item.id}}">-->
                        <v-btn small class="box-shadow mt-3" color="success" @click="openSelectedItemDialog(item)">
                          open
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-card>

                  <!--                <div @click="selected = session, selected_dialog = true" style="cursor: pointer;">-->
                  <!--                  <p class="ma-0" style="cursor: pointer; color: #9190b5">{{ session.name }}</p>-->
                  <!--                  <span>Start at: {{ $moment(session.start).format('DD MMMM YYYY hh:mm A') }}</span>-->
                  <!--                  <p>Attendance note: {{ session.include_an ? 'Yes' : 'No' }}</p>-->
                  <!--                </div>-->
                </v-timeline-item>

                <v-timeline-item v-if="sessions.length === 0" icon="">
                  <p class="pt-2">You have no upcoming events</p>
                </v-timeline-item>
              </v-timeline>
            </v-sheet>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="mb-4" v-if="profile_type === 'aspiringSolicitor'">
            <v-toolbar dense dark color="primary">
              My study groups
            </v-toolbar>
            <v-list-item v-for="stg in authUserStudyGroups" :key="stg.id" :to="{name: 'Study group', params: {study_group_id: stg.study_group.id}}">
              <v-list-item-icon>
                <template v-if="stg.status === 'approved'">
                  <v-icon>mdi-account-check-outline</v-icon>
                </template>
                <template v-else>
                  <v-icon>mdi-account-clock-outline</v-icon>
                </template>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ stg.study_group.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ $moment(stg.study_group.start_at).format('DD MMMM YYYY') }} - {{ $moment(stg.study_group.end_at).format('DD MMMM YYYY') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>

          <v-card v-if="profile_type === 'aspiringSolicitor'">
            <v-toolbar dense dark color="primary">
              Sessions
              <v-spacer/>
              <v-btn color="primary" :to="{name: 'Session limits'}">Buy more</v-btn>
            </v-toolbar>
            <v-data-table :headers="session_limits_headers"
                          :items="authUserSessionLimits"
                          :items-per-page="authUserSessionLimits.length"
                          dense
                          disable-pagination
                          hide-default-header
                          hide-default-footer>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card class="unselectable mb-3">
            <v-toolbar dark color="primary" dense>
              About us
            </v-toolbar>
            <v-card-text>
              <p>We are running OSCEsmart - a QLTS training provider offering an individually tailored training plan with a
                strong focus on the candidate’s practical skills. Among a variety of other QLTS preparation materials,
                OSCEsmart provides access to online mock stations.
                The mock-simulations can be conducted from the comfort of your home or office, and at any time you find suitable.
              </p>
              <br>
              <p class="mb-0 text-right">Operated by LEOPINION PTE. LTD, Reg No 201804437K</p>
              <p class="mb-0 text-right">70 BAYSHORE ROAD #13 ‐ 07 COSTA DEL SOL SINGAPORE 469987</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog max-width="500px" v-model="selected_item_dialog" @click:outside="closeSelectedItemDialog">
      <v-card v-if="selected_item">
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>Info</v-toolbar-title>
          <v-spacer/>
          <v-btn icon dark @click="closeSelectedItemDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ selected_item.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ selected_item.short_name }}</v-list-item-subtitle>

          </v-list-item-content>

          <v-list-item-action>
            <v-btn small class="box-shadow" color="success"
                   :to="{name: 'Classroom session', params: {session_id: selected_item.id}}">
              Open in classroom
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider/>

        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-timer</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>from {{ $moment(selected_item.start).format('DD MMMM YYYY HH:mm') }}</v-list-item-title>
            <v-list-item-subtitle>UK time zone</v-list-item-subtitle>
            <v-list-item-subtitle></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider/>
        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-alarm</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>to {{ $moment(selected_item.end).format('DD MMMM YYYY HH:mm') }}</v-list-item-title>
            <v-list-item-subtitle>UK time zone</v-list-item-subtitle>
            <v-list-item-subtitle></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider/>

        <template v-if="profile_type && profile_type !== 'aspiringSolicitor' && selected_item.user">
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Client's name</v-list-item-subtitle>
              <v-list-item-title>{{ selected_item.user.full_name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>

          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Client's nickname</v-list-item-subtitle>
              <v-list-item-title>{{ selected_item.user.nickname }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>

          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-email</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Client's e-mail</v-list-item-subtitle>
              <v-list-item-title>{{ selected_item.user.email }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>

          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-skype</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Client's skype</v-list-item-subtitle>
              <v-list-item-title>{{ selected_item.user.skype }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
  computed: {
    ...mapGetters({
      authUser: 'getAuthUser',
      profile_type: 'getAuthUserProfileType',
      profile_type_label: 'getAuthUserProfileTypeLabel',
      authUserSessionLimits: 'getAuthUserSessionLimits',
    }),
    isAspiringSolicitor: function () {
      if(!this.profile_type) return false
      return this.profile_type === 'aspiringSolicitor'
    }
  },
  data: () => ({
    session_limits_headers: [
      { text: 'Session type', value: 'name' },
      // { text: 'Type', value: 'status' },
      { text: 'Count', value: 'count' },
    ],
    sessions: [],
    selected_item: null,
    selected_item_dialog: false,
    date_from: null,
    date_to: null,
  }),
  created() {
    this.date_from = this.$currentTime().format('YYYY-MM-DD');
    this.date_to = this.$currentTime().add(1, 'month').format('YYYY-MM-DD');
    this.loadSessions()
    this.loadAuthUserSessionLimits()
  },
  methods: {
    ...mapActions({loadAuthUserSessionLimits: 'loadAuthUserSessionLimits'}),
    loadSessions() {
      this.axios.get('api/user/sessions', {
        params: {
          date_from: this.date_from,
          date_to: this.date_to,
        }
      }).then(({data}) => {
        let date_from = this.$moment(this.date_from, 'YYYY-MM-DD');
        let date_to = this.$moment(this.date_to, 'YYYY-MM-DD');
        let filter_range = this.$moment.range(date_from, date_to);
        this.sessions = data.data
            .filter(item => {
              if(filter_range.contains(this.$moment(item.start, 'YYYY-MM-DD'))) return item
              if(filter_range.contains(this.$moment(item.end, 'YYYY-MM-DD'))) return item
              let start = this.$moment(item.start, 'YYYY-MM-DD')
              let end = this.$moment(item.end, 'YYYY-MM-DD')
              let item_range = this.$moment.range(start, end);

              if(item_range.contains(this.$moment(date_from, 'YYYY-MM-DD'))) return item
              if(item_range.contains(this.$moment(date_to, 'YYYY-MM-DD'))) return item
            })
            .filter(item => !item.marked)
      })
    },
    getItemColor(item) {
      if(item.status === 'approved') return 'primary'
      if(item.status === 'invited') return 'success'
      return 'secondary'
    },

    openSelectedItemDialog(item) {
      this.selected_item = item
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
    },


  }

}
</script>